"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { ErrorSupportInfo } from "modules/common/components/ErrorSupportInfo";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="card bg-base-200 w-full max-w-md shadow-xl">
        <div className="card-body items-center text-center">
          <h2 className="card-title text-error">City Not Found</h2>
          <p className="text-base-content/70">
            We couldn&apos;t find the city you&apos;re looking for. This might
            be because:
          </p>
          <ul className="text-base-content/60 list-inside list-disc text-left text-sm">
            <li>The city name or country is misspelled</li>
            <li>The location doesn&apos;t exist in our database</li>
            <li>There was a temporary issue with our geocoding service</li>
          </ul>
          <div className="card-actions mt-4 w-full flex-col gap-2">
            <button
              onClick={() => {
                router.refresh();
                reset();
              }}
              className="btn btn-primary w-full"
            >
              Try Again
            </button>
            <Link href="/stores" className="btn btn-ghost w-full">
              Browse Stores
            </Link>
          </div>
          <ErrorSupportInfo className="mt-4" />
        </div>
      </div>
    </div>
  );
}
